import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/valuelist/ValueType/page', params)

// 删除
export const removeItem = id =>
  request.get(`/masterdata-api/valuelist/ValueType/delete/${id}`)

// 新增或更新菜单
export const updateOrAdd = params =>
  request.post('/masterdata-api/valuelist/ValueType/add', params)
